import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdmin } from '@/context/AdminContext';
import { LogIn } from 'lucide-react';
import { toast } from 'sonner';

const AdminLogin = () => {
  const navigate = useNavigate();
  const { login } = useAdmin();
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const success = await login(formData.username, formData.password);

    if (success) {
      toast.success('Login realizado com sucesso!');
      navigate('/admin/dashboard');
    } else {
      toast.error('Usuário ou senha inválidos');
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background bg-grid" data-testid="admin-login-page">
      <div className="w-full max-w-md p-8 bg-zinc-900/50 backdrop-blur-xl border border-white/10">
        <div className="text-center mb-8">
          <h1 className="font-heading text-3xl font-bold text-primary mb-2">DON'T <span className="text-white">ADMIN</span></h1>
          <p className="text-zinc-400 text-sm">Painel Administrativo</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6" data-testid="admin-login-form">
          <div>
            <label className="block text-sm uppercase tracking-wider text-zinc-400 mb-2">
              Usuário
            </label>
            <input
              type="text"
              value={formData.username}
              onChange={(e) => setFormData({ ...formData, username: e.target.value })}
              className="w-full bg-zinc-900 border border-zinc-800 focus:border-primary focus:ring-1 focus:ring-primary h-12 px-4 text-white"
              required
              data-testid="username-input"
            />
          </div>

          <div>
            <label className="block text-sm uppercase tracking-wider text-zinc-400 mb-2">
              Senha
            </label>
            <input
              type="password"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              className="w-full bg-zinc-900 border border-zinc-800 focus:border-primary focus:ring-1 focus:ring-primary h-12 px-4 text-white"
              required
              data-testid="password-input"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-primary text-black font-bold uppercase tracking-wider py-4 hover:bg-white transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
            data-testid="login-submit-button"
          >
            {loading ? (
              <div className="h-6 w-6 border-2 border-black border-t-transparent rounded-full animate-spin" />
            ) : (
              <>
                <LogIn className="h-5 w-5" />
                Entrar
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;